import { useFormikContext } from 'formik';
import React from 'react';
import text from '../../text';
import FormContainer from '../../components/containers/FormContainer';
var ForgotPasswordSuccess = function() {
    var values = useFormikContext().values;
    return /*#__PURE__*/ React.createElement(FormContainer, null, /*#__PURE__*/ React.createElement(FormContainer.SecondaryHeader, null, /*#__PURE__*/ React.createElement("h2", null, text('passwordResetSent'))), /*#__PURE__*/ React.createElement(FormContainer.Body, null, /*#__PURE__*/ React.createElement(FormContainer.PrimaryHeader, null, /*#__PURE__*/ React.createElement("h2", null, text('passwordResetSent'))), /*#__PURE__*/ React.createElement("p", {
        className: "text-center mb-2"
    }, text('checkInbox')), /*#__PURE__*/ React.createElement("p", {
        className: "text-center font-weight-bold"
    }, values.email)));
};
export default ForgotPasswordSuccess;
